import React, { useRef } from 'react';
import { Heading } from '@klp/design/Heading';
import { Illustration, IconName } from '@klp/design/Illustrations';
import { FileDownload } from '@klp/filedownload';
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import { contractToRegistrationApiRoutes } from '../config';
import type { DocumentInfo } from '../classes/DocumentInfo';
import { Block } from '@klp/design/index';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        borderColor: theme.palette.primary.medium,
        borderRadius: 2,
        border: '1px solid transparent',
    },
    iconContainer: {
        display: 'flex',
    },
    iconButton: {
        cursor: 'pointer',
    },
}));

type ContractDocumentProps = { contractDocument: DocumentInfo };

export const ContractDocument: React.FC<ContractDocumentProps> = ({
    contractDocument,
}) => {
    const classes = useStyles();
    const documentRef = useRef<HTMLDivElement>(null);

    return (
        <Grid container={true}>
            <Grid
                ref={documentRef}
                className={classes.container}
                item={true}
                md={9}
            >
                <Heading klpHeadingLevel="FIVE" klpColor="dark">
                    {contractDocument.name}
                </Heading>
                <Block className={classes.iconContainer}>
                    <IconButton>
                        <FileDownload
                            path={contractToRegistrationApiRoutes.download(
                                contractDocument.id,
                            )}
                            name={`${contractDocument.name}`}
                            preview={true}
                        >
                            <Illustration
                                className={classes.iconButton}
                                icon={IconName.SEARCH}
                                klpPalette="primary"
                                klpColor="main"
                            />
                        </FileDownload>
                    </IconButton>
                    <IconButton>
                        <FileDownload
                            path={contractToRegistrationApiRoutes.download(
                                contractDocument.id,
                            )}
                            name={`${contractDocument.name}`}
                        >
                            <Illustration
                                className={classes.iconButton}
                                icon={IconName.DOWNLOAD}
                                klpPalette="primary"
                                klpColor="main"
                            />
                        </FileDownload>
                    </IconButton>
                </Block>
            </Grid>
        </Grid>
    );
};
